import { motion } from "framer-motion";
import { useContext } from "react";
import { Link } from "react-router-dom";
import { ThemeContext } from "../../hooks/ThemeContext";
import { ArrowRight, Palette, ShoppingBag } from "lucide-react";

const CTASection = () => {
  const { theme } = useContext(ThemeContext);
  const isDark = theme === "dark";

  return (
    <section className={`py-16 ${isDark ? 'bg-[#0f1114] text-white' : 'bg-slate-50 text-gray-800'}`}>
      <div className="max-w-6xl mx-auto px-4">
        <div className={`rounded-2xl p-8 md:p-12 ${isDark ? 'bg-gradient-to-br from-rose-900/30 via-purple-900/30 to-blue-900/30 border border-white/10' : 'bg-gradient-to-br from-rose-100 via-purple-100 to-blue-100 border border-gray-200'}`}>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
            {/* Acheteurs */}
            <motion.div
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
              className={`p-6 rounded-xl ${isDark ? 'bg-white/5 border border-white/10' : 'bg-white border border-gray-200'}`}
            >
              <div className={`inline-block p-3 rounded-lg mb-4 ${isDark ? 'bg-rose-500/20' : 'bg-rose-100'}`}>
                <ShoppingBag className={`w-8 h-8 ${isDark ? 'text-rose-400' : 'text-rose-600'}`} />
              </div>
              <h3 className="text-2xl font-bold mb-3">
                Vous cherchez des créations ?
              </h3>
              <p className={`mb-6 ${isDark ? 'text-gray-300' : 'text-gray-600'}`}>
                Explorez notre marketplace et trouvez la création parfaite pour votre projet parmi des centaines d'options.
              </p>
              <Link 
                to="/shop"
                onClick={() => window.scrollTo(0, 0)}
                className={`inline-flex items-center gap-2 px-6 py-3 rounded-lg font-semibold transition-all hover:scale-105 ${isDark ? 'bg-rose-600 hover:bg-rose-700 text-white' : 'bg-rose-600 hover:bg-rose-700 text-white'}`}
              >
                Explorer la Boutique
                <ArrowRight className="w-4 h-4" />
              </Link>
            </motion.div>

            {/* Créateurs */}
            <motion.div
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className={`p-6 rounded-xl ${isDark ? 'bg-white/5 border border-white/10' : 'bg-white border border-gray-200'}`}
            >
              <div className={`inline-block p-3 rounded-lg mb-4 ${isDark ? 'bg-purple-500/20' : 'bg-purple-100'}`}>
                <Palette className={`w-8 h-8 ${isDark ? 'text-purple-400' : 'text-purple-600'}`} />
              </div>
              <h3 className="text-2xl font-bold mb-3">
                Vous êtes créateur ?
              </h3>
              <p className={`mb-6 ${isDark ? 'text-gray-300' : 'text-gray-600'}`}>
                Rejoignez notre communauté et commencez à vendre vos créations. Inscription gratuite, commissions équitables.
              </p>
              <Link 
                to="/devenir-createur"
                onClick={() => window.scrollTo(0, 0)}
                className={`inline-flex items-center gap-2 px-6 py-3 rounded-lg border font-semibold transition-all hover:scale-105 ${isDark ? 'border-white/20 hover:bg-white/10 text-white' : 'border-gray-300 hover:bg-white text-gray-800'}`}
              >
                Devenir Créateur
                <ArrowRight className="w-4 h-4" />
              </Link>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
